import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoutes";
import { AuthProvider } from "./contexts/AuthContext";
import { OrdersProvider } from "./contexts/OrdersContext"; 
import { SamplesProvider } from "./contexts/SamplesContext";
import "./Global.css";
import Login from './pages/login/Login';
import Dashboard from './pages/dashboard/Dashboard';
import Pedidos from './pages/pedidos/Pedidos';
import ImportarPedidos from './pages/importarpedidos/ImportarPedidos';
import VisualizarPedidos from './pages/visualizarpedidos/VisualizarPedidos';
import ReanaliseNir from './pages/reanalisenir/ReanaliseNir';

function App() {
  return (
    <AuthProvider>
      
      <Routes>
        <Route path="/login" element={<Login />} />

        {/* Protege todas as rotas dentro de ProtectedRoute */}
        <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route
              path="/pedidos"
              element={
                <OrdersProvider>
                  <Pedidos />
                </OrdersProvider>
              }
            />
            <Route
              path="/import"
              element={
                <OrdersProvider>
                  <ImportarPedidos />
                </OrdersProvider>
              }
            />
            <Route
              path="/pedidos/:numPedido"
              element={
                <OrdersProvider>
                  <VisualizarPedidos />
                </OrdersProvider>
              }
            />
            <Route 
              path="/reanalise/nir" 
              element={
                <SamplesProvider>
                  <ReanaliseNir />
                </SamplesProvider>
              } />
          </Route>

        {/* Rota padrão para evitar páginas inexistentes */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;